import BaseTicketSaleReport from 'Services/SalesManagement/Features/Report/Components/BaseTicketSaleReport'
import {
  createTicketSaleReport,
  fetchTicketSaleReport,
  resetTicketSaleReportWebsocket,
  TICKET_SALE_REPORT_PATH,
  TICKET_SALE_REPORT_PREFIX
} from 'Services/SalesManagement/Features/Report/reportSlice'
import useTypedSelector, { useAppDispatch } from 'Store'

export default function TicketSaleReport() {
  const dispatch = useAppDispatch()

  const {
    ticketSaleReportLoading,
    singleTicketSaleReport,
    ticketSaleReportGenerationStatus,
    ticketSaleReportGenerationTask
  } = useTypedSelector(state => state.report)

  return (
    <BaseTicketSaleReport
      reportLoading={ticketSaleReportLoading}
      singleReport={singleTicketSaleReport}
      reportGenerationStatus={ticketSaleReportGenerationStatus}
      reportGenerationTask={ticketSaleReportGenerationTask}
      reportPrefix={TICKET_SALE_REPORT_PREFIX}
      reportPath={TICKET_SALE_REPORT_PATH}
      onCreateReport={params => dispatch(createTicketSaleReport(params)).unwrap()}
      onFetchReport={(reportName, params) =>
        dispatch(fetchTicketSaleReport({ report_name: reportName, ...params })).unwrap()
      }
      onResetWebsocket={() => dispatch(resetTicketSaleReportWebsocket())}
    />
  )
}
